var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailsent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 485.638 485.638",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.689,156.996L328.642,12.949c-17.266-17.266-45.353-17.266-62.616,0L12.948,266.024 c-17.264,17.266-17.264,45.353,0,62.617L156.995,472.69c17.266,17.264,45.354,17.265,62.617,0l253.076-253.076 C489.954,202.348,489.952,174.26,472.689,156.996z M183.546,455.21c-2.064-0.707-4.031-1.745-5.68-3.393L33.819,307.771 c-0.039-0.041-0.048-0.092-0.09-0.133l149.816-0.001V455.21z M42.601,278.118L278.122,42.596l0.002,229.085 c-0.002,3.444-2.998,6.442-6.443,6.442L42.601,278.118z M213.06,437.498v-129.86h58.623c9.609,0,18.64-3.741,25.427-10.528 c6.788-6.788,10.527-15.817,10.528-25.428V213.06l129.854,0.005L213.06,437.498z M307.637,183.545V33.729 c0.04,0.041,0.093,0.05,0.134,0.091l144.047,144.047c1.646,1.647,2.685,3.613,3.388,5.683L307.637,183.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.382,62.57h151.154c7.941,0,14.381-6.438,14.381-14.38c0-7.942-6.439-14.381-14.381-14.381H14.382 c-7.943,0-14.381,6.438-14.381,14.381C0.001,56.132,6.439,62.57,14.382,62.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.382,119.065h94.784c7.942,0,14.38-6.438,14.38-14.381c0-7.941-6.438-14.38-14.38-14.38H14.382 c-7.943,0-14.381,6.438-14.381,14.38C0.001,112.627,6.439,119.065,14.382,119.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.382,173.849h61.197c7.941,0,14.381-6.438,14.381-14.381s-6.439-14.381-14.381-14.381H14.382 c-7.943,0-14.381,6.439-14.381,14.381S6.439,173.849,14.382,173.849z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.579,438.278H14.382c-7.943,0-14.381,6.439-14.381,14.381c0,7.942,6.438,14.381,14.381,14.381h61.197 c7.941,0,14.381-6.438,14.381-14.381C89.96,444.717,83.521,438.278,75.579,438.278z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsent);
export default __webpack_public_path__ + "static/media/emailsent.7b8c864b8b1012005f50804cb46697b6.svg";
export { ForwardRef as ReactComponent };